import { isProduction } from "../../../utils/urls";
export {
    isProduction,
    getIdentityBaseUrl,
    getWacIntegrationUrl
} from "../../../utils/urls";

const RECAPTCHA_KEY = "6LeTa5ocAAAAAJefQaFL-1ENlPNY3Wq2j-GhcZ6n";
const RECAPTCHA_KEY_TEST = "6Lf0JekdAAAAAAWT2kBc89gFVKhxkwTPxa-e9tvx";

export const getReCaptchaKey = () =>
    isProduction() ? RECAPTCHA_KEY : RECAPTCHA_KEY_TEST;
